import { MaatNcqStatus } from '../constants/maat-ncq-status.constants';

import { LoggedInUserRoleFlags } from '../interfaces/logged-in-user-role-flags.interface';

export class MaatNcqAccess {
  private loggedInUserRoleFlags: LoggedInUserRoleFlags;

  constructor(
    loggedInUserRoleFlags: LoggedInUserRoleFlags
  ) {
    this.loggedInUserRoleFlags = loggedInUserRoleFlags;
  }

  static readonly allNcqStatusesExceptDeleted: MaatNcqStatus[] = Object.values(MaatNcqStatus).filter(value => value !== MaatNcqStatus.deleted);

  static readonly maatHeadContractorStatuses = [
    MaatNcqStatus.informationRequested,
    MaatNcqStatus.informationOverdue,
    MaatNcqStatus.spoInformationRequested,
    MaatNcqStatus.spoInformationOverdue
  ];

  private loggedInUserRoleIsMaatManager = () =>
      this.loggedInUserRoleFlags?.isMaatManager ?? false;

  private loggedInUserRoleIsMaatProjectOfficer = () =>
      this.loggedInUserRoleFlags?.isMaatProjectOfficer ?? false;

  private loggedInUserRoleIsMaatSeniorProjectOfficer = () =>
    this.loggedInUserRoleFlags?.isMaatSeniorProjectOfficer ?? false;

  private loggedInUserRoleIsMaatHeadContractor = () =>
    this.loggedInUserRoleFlags?.isMaatHeadContractor ?? false;

  canIssueNewNcqs(): boolean {
    return this.loggedInUserRoleIsMaatProjectOfficer() || this.loggedInUserRoleIsMaatSeniorProjectOfficer();
  }

  canReIssueNcqs(): boolean {
    return this.loggedInUserRoleIsMaatSeniorProjectOfficer();
  }

  getDefaultNcqStatuses(): MaatNcqStatus[] {
    const defaultNcqStatuses = this.loggedInUserRoleFlags.isMaatHeadContractor
      ? MaatNcqAccess.maatHeadContractorStatuses
      : MaatNcqAccess.allNcqStatusesExceptDeleted;
    return defaultNcqStatuses;
  }
}
